<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{ $ml.get('shared.batchOperations') }}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{ $ml.get('shared.dashboard') }}</span>
        </li>
        <li>
          <span>{{ $ml.get('shared.batchOperations') }}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-md-4">
          <div class="box box-primary">
            <div class="box-header with-border" align="center">
              <h3 class="box-title">{{ $ml.get('batchOperations.filterTheEmployeesYouWantToSelect') }}</h3>
            </div>
            <div class="box-body">
              <div class="form-group col-sm-6" align="center">
                <button class="btn btn-primary " data-toggle="modal" data-target="#modal-filtre" style="width:100%;">
                  <i class="fa fa-search"></i>
                  <span>{{ $ml.get('filters.filterEmployees') }}</span>
                </button>
              </div>
              <div class="form-group col-sm-6" align="center">
                <button @click="checkEmployees()" class="btn btn-primary " style="width:100%;">
                  <span v-show="!isCheck">{{ $ml.get('general.selectAll') }}</span>
                  <span v-show="isCheck">{{ $ml.get('general.removeAll') }}</span>
                </button>
              </div>
              <div class="input-group col-sm-12" style="margin-bottom:7px; margin-top:7px;">
                <input v-model="searchText" class="form-control"
                  :placeholder="$ml.get('batchOperations.searchEmployeeFromList')" />
                <span class="input-group-btn">
                  <button type="button" class="btn btn-primary ">
                    <i class="fa fa-search"></i>
                  </button>
                </span>
              </div>
              <div v-show="employeeFilteredList.length > 0" class="table-responsive no-padding"
                :style="windowHeightSize">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th></th>
                      <th @click="setOrderEmp(1)" style="cursor:pointer;min-width:75px;">
                        <strong>
                          {{ $ml.get('employees.registrationNumberInfo') }}
                          <i v-show="orderEmpList == 1" class="fa fa-sort-numeric-asc"></i>
                          <i v-show="orderEmpList == 2" class="fa fa-sort-numeric-desc"></i>
                        </strong>
                      </th>
                      <th @click="setOrderEmp(2)" style="cursor:pointer;">
                        <strong>
                          {{ $ml.get('employees.nameSurname') }}
                          <i v-show="orderEmpList == 3" class="fa fa-sort-alpha-asc"></i>
                          <i v-show="orderEmpList == 4" class="fa fa-sort-alpha-desc"></i>
                        </strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style="cursor:pointer;" v-for="employee3 in filtered" :key="employee3.id"
                      @click="employee3.check == true ? employee3.check = false : employee3.check = true">
                      <td style="font-size:18px;">
                        <i v-if="employee3.check" class="fa fa-check-circle text-success"></i>
                        <i v-else class="fa fa-times-circle text-danger"></i>
                      </td>
                      <td>{{ employee3.sicilNo }}</td>
                      <td>
                        {{ employee3.name }}
                        <span v-if="employee3.title != ''">({{ employee3.title }})</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="employeeFilteredList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i>
                {{ $ml.get('batchOperations.employeeNotRecord') }}
              </div>
            </div>
            <div class="overlay" :hidden="!isLoadingEmployee">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-md-8">
          <div class="box box-solid">
            <div class="box-body" align="center">
              <h4
                style="background-color:#f7f7f7; font-size: 18px; text-align: center; padding: 7px 10px; margin-top: 0;">
                {{ $ml.get('batchOperations.chooseFromTheFollowingActions') }}</h4>
              <a href="#bilgi-guncelleme" data-toggle="tab"
                :title="$ml.get('batchOperations.informationUpdateOperations')" class="btn btn-app">
                <i class="fa fa-info-circle"></i>
                <span>{{ $ml.get('batchOperations.informationUpdate') }}</span>
              </a>
              <a href="#izinler" data-toggle="tab" :title="$ml.get('batchOperations.allowenceOperations')"
                class="btn btn-app">
                <i class="fa fa-plane"></i>
                <span>{{ $ml.get('batchOperations.allowence') }}</span>
              </a>
              <a href="#hareketler" data-toggle="tab" :title="$ml.get('batchOperations.movementOperations')"
                class="btn btn-app">
                <i class="fa fa-exchange"></i>
                <span>{{ $ml.get('batchOperations.movement') }}</span>
              </a>
              <a v-show="modules.payroll" href="#fazla-mesailer" data-toggle="tab"
                :title="$ml.get('batchOperations.overtimeOperations')" class="btn btn-app">
                <i class="fa fa-calendar-check-o"></i>
                <span>{{ $ml.get('batchOperations.overtime') }}</span>
              </a>
              <a v-show="modules.payroll" href="#puantaj" data-toggle="tab"
                :title="$ml.get('batchOperations.payrollOperations')" class="btn btn-app">
                <i class="fa fa-clock-o"></i>
                <span>{{ $ml.get('batchOperations.payroll') }}</span>
              </a>
              <a href="#calisma-gruplari" data-toggle="tab" :title="$ml.get('batchOperations.workPlanOperations')"
                class="btn btn-app">
                <i class="fa fa-briefcase"></i>
                <span>{{ $ml.get('batchOperations.workPlan') }}</span>
              </a>
              <a v-show="modules.diningHall" href="#yemekhane" data-toggle="tab"
                :title="$ml.get('batchOperations.diningHall')" class="btn btn-app">
                <i class="fa fa-cutlery"></i>
                <span>{{ $ml.get('batchOperations.diningHall') }}</span>
              </a>
              <a href="#gorev-yeri" data-toggle="tab" :title="$ml.get('employees.workPlace')" class="btn btn-app">
                <i class="fa fa-building"></i>
                <span>{{ $ml.get('employees.workPlace') }}</span>
              </a>
              <!--<a
                href="#fazla-mesai-planlama"
                data-toggle="tab"
                title="Fazla Mesai Planlama"
                class="btn btn-app"
              >
                <i class="fa fa-calendar-plus-o"></i>
                <span>FM Planlama</span>
              </a>
              <a
                href="#fazla-mesai-onaylama"
                data-toggle="tab"
                title="Fazla Mesai Onaylama"
                class="btn btn-app"
              >
                <i class="fa fa-calendar-check-o"></i>
                <span>FM Onaylama</span>
              </a>-->
            </div>
          </div>
          <div class="tab-content">
            <div class="tab-pane active" id="bilgi-guncelleme">
              <div class="box box-primary">
                <div class="box-body">
                  <h4
                    style="background-color:#f7f7f7; font-size: 18px; text-align: center; padding: 7px 10px; margin-top: 0;">
                    {{ $ml.get('batchOperations.informationUpdateOperations') }}</h4>
                  <div class="form-group col-sm-12">
                    <label>{{ $ml.get('batchOperations.department') }}</label>
                    <select @change="changeDepartment($event)" class="form-control">
                      <option selected value="0">{{ $ml.get('general.notChanged') }}</option>
                      <option v-for="dep in departmentList" :key="dep.id" :value="dep.id">{{ dep.name }}</option>
                    </select>
                  </div>
                  <div class="form-group col-sm-12">
                    <label>{{ $ml.get('batchOperations.status') }}</label>
                    <select @change="changeStatu($event)" class="form-control">
                      <option selected value="0">{{ $ml.get('general.notChanged') }}</option>
                      <option v-for="statu in statuList" :key="statu.id" :value="statu.id">{{ statu.name }}</option>
                    </select>
                  </div>
                  <div class="form-group col-sm-12">
                    <label>{{ $ml.get('batchOperations.state') }}</label>
                    <select @change="changeState($event)" class="form-control">
                      <option selected value="0">{{ $ml.get('general.notChanged') }}</option>
                      <option v-for="state in stateList" :key="state.id" :value="state.id">{{ state.name }}</option>
                    </select>
                  </div>
                  <div class="form-group col-sm-12">
                    <label>{{ $ml.get('batchOperations.foodGroup') }}</label>
                    <select @change="changeFoodGroup($event)" class="form-control">
                      <option selected value="0">{{ $ml.get('general.notChanged') }}</option>
                      <option v-for="foodGroup in foodGroupList" :key="foodGroup.id" :value="foodGroup.id">
                        {{ foodGroup.name }}</option>
                    </select>
                  </div>
                  <div class="form-group col-sm-12">
                    <label>{{ $ml.get('batchOperations.accessGroup') }}</label>
                    <select @change="changeAccessGroup($event)" class="form-control">
                      <option selected value="0">{{ $ml.get('general.notChanged') }}</option>
                      <option v-for="accessGroup in accessGroupList" :key="accessGroup.id" :value="accessGroup.id">
                        {{ accessGroup.name }}</option>
                    </select>
                  </div>
                  <div class="form-group col-sm-6">
                    <label>{{ $ml.get('batchOperations.validityStartDate') }}</label>
                    <input v-model="batchInfo.newValidityStartDate" type="date" class="form-control" />
                  </div>
                  <div class="form-group col-sm-6">
                    <label>{{ $ml.get('batchOperations.validityEndDate') }}</label>
                    <input v-model="batchInfo.newValidityEndDate" type="date" class="form-control" />
                  </div>
                </div>
                <div class="overlay" :hidden="!isLoading">
                  <i class="fa fa-refresh fa-spin"></i>
                </div>
                <div class="box-footer" v-show="authControl == 0">
                  <button @click="setBatchInformation()" class="btn btn-success  pull-right">
                    <i class="fa fa-check"></i>
                    {{ $ml.get('general.apply') }}
                  </button>
                </div>
              </div>
            </div>
            <div class="tab-pane" id="izinler">
              <div class="box box-primary">
                <div class="box-body">
                  <h4
                    style="background-color:#f7f7f7; font-size: 18px; text-align: center; padding: 7px 10px; margin-top: 0;">
                    {{ $ml.get('batchOperations.allowenceOperations') }}</h4>
                  <div class="form-group col-sm-6">
                    <label>{{ $ml.get('batchOperations.startDate') }}</label>
                    <input v-model="batchAllowence.startDate" type="datetime-local" class="form-control" />
                  </div>
                  <div class="form-group col-sm-6">
                    <label>{{ $ml.get('batchOperations.endDate') }}</label>
                    <input v-model="batchAllowence.endDate" type="datetime-local" class="form-control" />
                  </div>
                  <div class="col-sm-4 table-responsive" style="height:350px; overflow:auto;">
                    <h4>{{ $ml.get('batchOperations.validDays') }}</h4>
                    <table class="table table-hover">
                      <tbody>
                        <tr v-for="day in dayList" :key="day.value">
                          <td class="checkbox">
                            <label style="margin-left:30px">
                              <input type="checkbox" name="check" :checked="day.check"
                                @change="day.check == true ? day.check = false : day.check = true" />
                              {{ day.name }}
                            </label>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="form-group col-sm-8">
                    <label>{{ $ml.get('batchOperations.allowenceType') }}</label>
                    <select @change="changeAllowenceType($event)" class="form-control">
                      <option :selected="batchAllowence.allowenceType == 0" value="0">
                        {{ $ml.get('batchOperations.dailyAllowence') }}</option>
                      <option :selected="batchAllowence.allowenceType == 1" value="1">
                        {{ $ml.get('batchOperations.hourlyAllowence') }}</option>
                    </select>
                  </div>
                  <div class="form-group col-sm-8">
                    <label>{{ $ml.get('batchOperations.allowence') }}</label>
                    <select @change="changeAllowence($event)" class="form-control">
                      <option selected>{{ $ml.get('general.notSelected') }}</option>
                      <option v-for="allowence in allowenceList" :key="allowence.id" :value="allowence.id">
                        {{ allowence.name }}</option>
                    </select>
                  </div>
                  <div v-show="batchAllowence.allowenceType == 1" class="form-group col-sm-4">
                    <label>{{ $ml.get('batchOperations.totalTimeAllowence') }}</label>
                    <input type="time" class="form-control" v-model="batchAllowence.allowenceTime" />
                  </div>
                  <div v-show="batchAllowence.allowenceType == 1" class="form-group col-sm-4">
                    <label>{{ $ml.get('batchOperations.missingHourAllowence') }}</label>
                    <input type="time" class="form-control" v-model="batchAllowence.missingTime" />
                  </div>
                  <div v-show="batchAllowence.allowenceType == 1" class="form-group col-sm-8">
                    <label>{{ $ml.get('batchOperations.isEqualTheMissingTime') }}</label>
                    <span class="form-control checkbox">
                      <label style="margin-left:20px;">
                        <input :checked="batchAllowence.equalTheMissingTime"
                          @change="batchAllowence.equalTheMissingTime == true ? batchAllowence.equalTheMissingTime = false : batchAllowence.equalTheMissingTime = true"
                          type="checkbox" />
                        {{ $ml.get('batchOperations.equalTheMissingTime') }}
                      </label>
                    </span>
                  </div>
                  <div v-show="batchAllowence.allowenceType == 0" class="form-group col-sm-8">
                    <label>{{ $ml.get('batchOperations.doesApplyHolidays') }}</label>
                    <span class="form-control checkbox">
                      <label style="margin-left:20px;">
                        <input :checked="batchAllowence.holidayPass"
                          @change="batchAllowence.holidayPass == true ? batchAllowence.holidayPass = false : batchAllowence.holidayPass = true"
                          type="checkbox" />
                        {{ $ml.get('batchOperations.applyHolidays') }}
                      </label>
                    </span>
                  </div>
                  <div class="form-group col-sm-8">
                    <label>{{ $ml.get('batchOperations.descriptionAllowence') }}</label>
                    <input v-model="batchAllowence.description" type="text" class="form-control" />
                  </div>
                </div>
                <div class="overlay" :hidden="!isLoading">
                  <i class="fa fa-refresh fa-spin"></i>
                </div>
                <div class="box-footer" v-show="authControl == 0">
                  <button @click="setBatchAllowence()" class="btn btn-success  pull-right">
                    <i class="fa fa-check"></i>
                    {{ $ml.get('general.apply') }}
                  </button>
                </div>
              </div>
            </div>
            <div class="tab-pane" id="hareketler">
              <div class="box box-primary">
                <div class="box-body">
                  <h4
                    style="background-color:#f7f7f7; font-size: 18px; text-align: center; padding: 7px 10px; margin-top: 0;">
                    {{ $ml.get('batchOperations.movementOperations') }}</h4>
                  <div class="form-group col-sm-6">
                    <label>{{ $ml.get('batchOperations.startDate') }}</label>
                    <input v-model="batchMovement.startDate" type="date" class="form-control" />
                  </div>
                  <div class="form-group col-sm-6">
                    <label>{{ $ml.get('batchOperations.endDate') }}</label>
                    <input v-model="batchMovement.endDate" type="date" class="form-control" />
                  </div>
                  <div class="col-sm-4 table-responsive" style="height:350px; overflow:auto;">
                    <h4>{{ $ml.get('batchOperations.validDays') }}</h4>
                    <table class="table table-hover">
                      <tbody>
                        <tr v-for="day in dayList" :key="day.value">
                          <td class="checkbox">
                            <label style="margin-left:30px">
                              <input type="checkbox" name="check" :checked="day.check"
                                @change="day.check == true ? day.check = false : day.check = true" />
                              {{ day.name }}
                            </label>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-sm-8">
                    <h4>{{ $ml.get('batchOperations.movementDetails') }}</h4>
                    <div class="form-group">
                      <label>{{ $ml.get('batchOperations.movementTime') }}</label>
                      <input type="time" class="form-control" v-model="batchMovement.entryTime" />
                    </div>
                    <div class="form-group">
                      <label>{{ $ml.get('batchOperations.reader') }}</label>
                      <select class="form-control" @change="changeEntryDevice($event)">
                        <option selected>{{ $ml.get('general.notSelected') }}</option>
                        <option v-for="entryReader in readerList" :key="entryReader.readerId"
                          :value="entryReader.readerId">{{ entryReader.name }}</option>
                      </select>
                    </div>
                    <div class="form-group">
                      <label>{{ $ml.get('batchOperations.movementType') }}</label>
                      <select @change="changeEntryStatus($event)" class="form-control">
                        <option :selected="batchMovement.entryPointStatus == 1" value="1">
                          {{ $ml.get('batchOperations.entryMovement') }}</option>
                        <option :selected="batchMovement.entryPointStatus == 2" value="2">
                          {{ $ml.get('batchOperations.exitMovement') }}</option>
                      </select>
                    </div>
                    <div class="form-group">
                      <span class="form-control checkbox">
                        <label style="margin-left:20px;">
                          <input :checked="batchMovement.isTwoMovement"
                            @change="batchMovement.isTwoMovement == true ? batchMovement.isTwoMovement = false : batchMovement.isTwoMovement = true"
                            type="checkbox" />
                          {{ $ml.get('batchOperations.createExitMovement') }}
                        </label>
                      </span>
                    </div>
                    <div v-show="batchMovement.isTwoMovement">
                      <div class="form-group">
                        <label>{{ $ml.get('batchOperations.secondMovementTime') }}</label>
                        <input type="time" class="form-control" v-model="batchMovement.exitTime" />
                      </div>
                      <div class="form-group">
                        <label>{{ $ml.get('batchOperations.secondMovementReader') }}</label>
                        <select class="form-control" @change="changeExitDevice($event)">
                          <option selected>{{ $ml.get('general.notSelected') }}</option>
                          <option v-for="exitReader in readerList" :key="exitReader.readerId"
                            :value="exitReader.readerId">{{ exitReader.name }}</option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label>{{ $ml.get('batchOperations.secondMovementType') }}</label>
                        <select @change="changeExitStatus($event)" class="form-control">
                          <option :selected="batchMovement.exitPointStatus == 1" value="1">
                            {{ $ml.get('batchOperations.entryMovement') }}</option>
                          <option :selected="batchMovement.exitPointStatus == 2" value="2">
                            {{ $ml.get('batchOperations.exitMovement') }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="overlay" :hidden="!isLoading">
                  <i class="fa fa-refresh fa-spin"></i>
                </div>
                <div class="box-footer" v-show="authControl == 0">
                  <button @click="setBatchMovement()" class="btn btn-success  pull-right">
                    <i class="fa fa-check"></i>
                    {{ $ml.get('general.apply') }}
                  </button>
                </div>
              </div>
            </div>
            <div class="tab-pane" id="fazla-mesailer">
              <div class="box box-primary">
                <div class="box-body">
                  <h4
                    style="background-color:#f7f7f7; font-size: 18px; text-align: center; padding: 7px 10px; margin-top: 0;">
                    {{ $ml.get('batchOperations.confirmOvertime') }}</h4>
                  <div class="form-group col-sm-4">
                    <label>{{ $ml.get('batchOperations.startDate') }}</label>
                    <input v-model="batchOvertime.startDate" type="date" class="form-control" />
                  </div>
                  <div class="form-group col-sm-4">
                    <label>{{ $ml.get('batchOperations.endDate') }}</label>
                    <input v-model="batchOvertime.endDate" type="date" class="form-control" />
                  </div>
                  <div class="col-sm-4">
                    <button class="btn btn-primary " @click="getBatchOvertimes()" style="width:100%;margin-top:25px;">
                      <i class="fa fa-search"></i>
                      {{ $ml.get('batchOperations.search') }}
                    </button>
                  </div>
                  <hr />
                  <div class="col-sm-12 table-responsive" :style="windowHeightConfirmOvertimeSize">
                    <h4 class="text-center">{{ $ml.get('batchOperations.overtimeWorks') }}</h4>
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th>{{ $ml.get('batchOperations.nameSurname') }}</th>
                          <th class="text-center">{{ $ml.get('batchOperations.date') }}</th>
                          <th class="text-center">{{ $ml.get('batchOperations.workPlan') }}</th>
                          <th class="text-center">{{ $ml.get('batchOperations.entryMovement') }}</th>
                          <th class="text-center">{{ $ml.get('batchOperations.exitMovement') }}</th>
                          <th class="text-center">{{ $ml.get('batchOperations.calculated') }}</th>
                          <th class="text-center">{{ $ml.get('batchOperations.confirmed') }}</th>
                          <th class="text-center">
                            <button class="btn-link" @click="checkAllOvertime()">
                              <span v-show="!isCheckOvertime">{{ $ml.get('general.selectAll') }}</span>
                              <span class="text-danger" v-show="isCheckOvertime">{{ $ml.get('general.removeAll')
                                }}</span>
                            </button>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="overtime in batchOvertimeList" :key="overtime.overTimeId">
                          <td>{{ overtime.sicilNo }} - {{ overtime.name }}</td>
                          <td class="text-center">{{ overtime.date | toDateFormatGet("gg.aa.yyyy") }}</td>
                          <td class="text-center">{{ overtime.workGroupName }}</td>
                          <td class="text-center">{{ overtime.entry }}</td>
                          <td class="text-center">{{ overtime.exit }}</td>
                          <td class="text-center">{{ overtime.calculated }}</td>
                          <td class="text-center">
                            <input type="time" :style="overtimeStyleControl(overtime.calculated, overtime.confirmed)"
                              @change="overtimeControl(overtime.calculated, overtime.confirmed, overtime.sicilNo + ' - ' + overtime.name, overtime.date)"
                              v-model="overtime.confirmed" />
                          </td>
                          <td class="text-center">
                            <input type="checkbox" :checked="overtime.check"
                              @change="overtime.check == true ? overtime.check = false : overtime.check = true" />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="overlay" :hidden="!isLoading">
                  <i class="fa fa-refresh fa-spin"></i>
                </div>
                <div class="box-footer" v-show="authControl == 0">
                  <button @click="setBatchOvertime()" class="btn btn-success  pull-right">
                    <i class="fa fa-check"></i>
                    {{ $ml.get('general.apply') }}
                  </button>
                </div>
              </div>
            </div>
            <div class="tab-pane" id="puantaj">
              <div class="box box-primary">
                <div class="box-body">
                  <h4
                    style="background-color:#f7f7f7; font-size: 18px; text-align: center; padding: 7px 10px; margin-top: 0;">
                    {{ $ml.get('batchOperations.payrollOperations') }}</h4>
                  <div class="form-group col-sm-12">
                    <label>{{ $ml.get('batchOperations.startTime') }}</label>
                    <input v-model="batchPayrollStartDate" type="datetime-local" class="form-control" />
                  </div>
                  <div class="form-group col-sm-6">
                    <label>{{ $ml.get('batchOperations.includePassivesMovement') }}</label>
                    <span class="form-control checkbox">
                      <label style="margin-left:20px;">
                        <input :checked="includePassiveMovements"
                          @change="includePassiveMovements == true ? includePassiveMovements = false : includePassiveMovements = true"
                          type="checkbox" />
                        {{ $ml.get('batchOperations.includePassivesMovement') }}
                      </label>
                    </span>
                  </div>
                  <div class="form-group col-sm-6">
                    <label>{{ $ml.get('batchOperations.confirmedOvertimeNotDeleted') }}</label>
                    <span class="form-control checkbox">
                      <label style="margin-left:20px;">
                        <input :checked="doNotDeleteOvertimes"
                          @change="doNotDeleteOvertimes == true ? doNotDeleteOvertimes = false : doNotDeleteOvertimes = true"
                          type="checkbox" />
                        {{ $ml.get('batchOperations.confirmedOvertimeNotDeleted') }}
                      </label>
                    </span>
                  </div>
                </div>
                <div class="overlay" :hidden="!isLoading">
                  <i class="fa fa-refresh fa-spin"></i>
                </div>
                <div class="box-footer" v-show="authControl == 0">
                  <button @click="setBatchPayroll()" class="btn btn-success  pull-right">
                    <i class="fa fa-check"></i>
                    {{ $ml.get('general.apply') }}
                  </button>
                </div>
              </div>
            </div>
            <div class="tab-pane" id="calisma-gruplari">
              <div class="box box-primary">
                <div class="box-body">
                  <h4
                    style="background-color:#f7f7f7; font-size: 18px; text-align: center; padding: 7px 10px; margin-top: 0;">
                    {{ $ml.get('batchOperations.workPlanOperations') }}</h4>
                  <div class="form-group col-sm-6">
                    <label>{{ $ml.get('batchOperations.startTime') }}</label>
                    <input v-model="batchWorkGroup.startDate" type="datetime-local" class="form-control" />
                  </div>
                  <div class="form-group col-sm-6">
                    <label>{{ $ml.get('batchOperations.endTime') }}</label>
                    <input v-model="batchWorkGroup.endDate" type="datetime-local" class="form-control" />
                  </div>
                  <div class="form-group col-sm-6">
                    <label>{{ $ml.get('batchOperations.workPlan') }}</label>
                    <select @change="changeWorkGroup($event)" class="form-control">
                      <option selected>{{ $ml.get('general.notSelected') }}</option>
                      <option v-for="workGroup in workGroupList" :key="workGroup.id" :value="workGroup.id">
                        {{ workGroup.shortCode }} - {{ workGroup.name }}</option>
                    </select>
                  </div>
                  <div class="form-group col-sm-6">
                    <label>{{ $ml.get('batchOperations.doesApplyHolidays') }}</label>
                    <span class="form-control checkbox">
                      <label style="margin-left:20px;">
                        <input :checked="batchWorkGroup.holidayPass"
                          @change="batchWorkGroup.holidayPass == true ? batchWorkGroup.holidayPass = false : batchWorkGroup.holidayPass = true"
                          type="checkbox" />
                        {{ $ml.get('batchOperations.applyHolidays') }}
                      </label>
                    </span>
                  </div>
                  <div class="form-group col-sm-12">
                    <label>{{ $ml.get('batchOperations.descriptionWorkPlan') }}</label>
                    <input v-model="batchWorkGroup.description" type="text" class="form-control" />
                  </div>
                </div>
                <div class="overlay" :hidden="!isLoading">
                  <i class="fa fa-refresh fa-spin"></i>
                </div>
                <div class="box-footer" v-show="authControl == 0">
                  <button @click="setBatchWorkGroup()" class="btn btn-success  pull-right">
                    <i class="fa fa-check"></i>
                    {{ $ml.get('general.apply') }}
                  </button>
                </div>
              </div>
            </div>
            <div class="tab-pane" id="yemekhane">
              <div class="box box-primary">
                <div class="box-body">
                  <h4
                    style="background-color:#f7f7f7; font-size: 18px; text-align: center; padding: 7px 10px; margin-top: 0;">
                    {{ $ml.get('batchOperations.diningHallOperations') }}</h4>
                  <div class="col-sm-6 text-center" style="margin-top: 20px;">
                    <button @click="downloadExcelTemplate()" class="btn btn-primary btn-lg"><i
                        class="fa fa-download"></i>
                      {{ $ml.get('batchOperations.downloadTemplate') }}</button>
                  </div>
                  <div class="col-sm-6 text-center" style="margin-top: 20px;">
                    <div class="form-group">
                      <input type="file" ref="file" class="form-control" accept=".xlsx" hidden
                        style="justify-self: center;border:1px solid grey; border-radius: 5px;">
                      <p class="help-block">{{ $ml.get('batchOperations.uploadDescription') }}</p>
                    </div>
                    <button class="btn btn-primary btn-lg" @click="uploadExcelTemplate" v-show="authControl == 0"><i
                        class="fa fa-upload"></i>
                      {{ $ml.get('batchOperations.uploadFile') }}</button>
                  </div>

                </div>
                <div class="overlay" :hidden="!isLoading">
                  <i class="fa fa-refresh fa-spin"></i>
                </div>
              </div>
            </div>
            <!--<div class="tab-pane" id="fazla-mesai-planlama">
                      <h4
                        style="background-color:#f7f7f7; font-size: 18px; text-align: center; padding: 7px 10px; margin-top: 0;"
                      >Fazla Mesai Planlama İşlemleri</h4>
                    </div>
                    <div class="tab-pane" id="fazla-mesai-onaylama">
                      <h4
                        style="background-color:#f7f7f7; font-size: 18px; text-align: center; padding: 7px 10px; margin-top: 0;"
                      >Fazla Mesai Onaylama İşlemleri</h4>
            </div>-->
            <div class="tab-pane" id="gorev-yeri">
              <div class="box box-primary">
                <div class="box-body">
                  <div class="form-group col-sm-12">
                    <label>{{ $ml.get('employees.workPlace') }}</label>
                    <select @change="changeWorkPlace($event)" class="form-control">
                      <option selected value="0">{{ $ml.get('general.notChanged') }}</option>
                      <option v-for="workPlace in workPlaceDefinitionList" :key="workPlace.id" :value="workPlace.id">{{
                        workPlace.name }}</option>
                    </select>
                  </div>
                  <div class="form-group col-sm-12">
                    <label>{{ $ml.get('employees.workPlaceDescription') }}</label>
                    <input v-model="workPlaces.description" type="text" class="form-control" />
                  </div>
                  <div class="form-group col-sm-6">
                    <label>{{ $ml.get('employees.workPlaceStartDate') }}</label>
                    <input v-model="workPlaces.startDate" type="date" class="form-control" />
                  </div>
                  <div class="form-group col-sm-6">
                    <label>{{ $ml.get('employees.workPlaceEndDate') }}</label>
                    <input v-model="workPlaces.endDate" type="date" class="form-control" />
                  </div>
                </div>
                <div class="overlay" :hidden="!isLoading">
                  <i class="fa fa-refresh fa-spin"></i>
                </div>
                <div class="box-footer" v-show="authControl == 0">
                  <button @click="setBatchWorkPlace()" class="btn btn-success  pull-right">
                    <i class="fa fa-check"></i>
                    {{ $ml.get('general.apply') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL START-->
      <div class="modal modal-primary fade" id="modal-filtre">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterEmployees') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <span>{{ $ml.get('filters.filterNameSurnameOrCardNo') }}</span>
                    <input v-model="filters.nameOrCardNumber" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterNameSurnameOrCardNo')" style="margin-bottom:5px;" />
                  </div>
                  <div class="form-group">
                    <span>{{ $ml.get('filters.filterCitizenshipNumber') }}</span>
                    <input v-model="filters.identityNo" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterCitizenshipNumber')" style="margin-bottom:5px;" />
                  </div>
                  <div class="form-group">
                    <span>{{ $ml.get('filters.filterRegistrationOrDeviceNo') }}</span>
                    <input v-model="filters.sicilOrTerminalNo" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterRegistrationOrDeviceNo')" style="margin-bottom:5px;" />
                  </div>
                  <div class="form-group">
                    <span>{{ $ml.get('filters.filterTitle') }}</span>
                    <select @change="changeFilterTitles($event)" class="form-control input-sm"
                      style="margin-bottom:5px;">
                      <option :selected="filters.title == ''" value>{{ $ml.get('general.select') }}</option>
                      <option v-for="title in titleList" :key="title.name" :value="title.name"
                        :selected="title.name == filters.title">{{ title.name }}</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>{{ $ml.get('filters.filterStatus') }}</label>
                    <div class="input-group">
                      <label v-show="checkedStatusList != ''" class="form-control tdb-box">{{ checkedStatusList
                        }}</label>
                      <label v-show="checkedStatusList == ''" class="form-control">{{ $ml.get('general.notSelected')
                        }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-status">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedStatusList != ''" class="btn btn-danger" @click="clearFilterStatus()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <span>{{ $ml.get('filters.filterDocumentNoOrEmail') }}</span>
                    <input v-model="filters.documentNoOrMail" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterDocumentNoOrEmail')" style="margin-bottom:5px;" />
                  </div>
                  <div class="form-group" v-show="modules.licencePlateRecognition">
                    <span>{{ $ml.get('filters.filterPlateNo') }}</span>
                    <input v-model="filters.plateNo" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterPlateNo')" style="margin-bottom:5px;" />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>{{ $ml.get('filters.filterDepartments') }}</label>
                    <div class="input-group">
                      <label v-show="checkedDepartmentList != ''" class="form-control tdb-box">{{ checkedDepartmentList
                        }}</label>
                      <label v-show="checkedDepartmentList == ''" class="form-control">{{ $ml.get('general.notSelected')
                        }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-department">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedDepartmentList != ''" class="btn btn-danger"
                          @click="clearFilterDepartments()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>{{ $ml.get('filters.filterAccessGroup') }}</label>
                    <div class="input-group">
                      <label v-show="checkedAccessGroupList != ''" class="form-control tdb-box">{{
                        checkedAccessGroupList }}</label>
                      <label v-show="checkedAccessGroupList == ''" class="form-control">{{
                        $ml.get('general.notSelected') }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-access">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedAccessGroupList != ''" class="btn btn-danger"
                          @click="clearFilterAccessGroup()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>{{ $ml.get('filters.filterWorkPlan') }}</label>
                    <div class="input-group">
                      <label v-show="checkedWorkGroupList != ''" class="form-control tdb-box">{{ checkedWorkGroupList
                        }}</label>
                      <label v-show="checkedWorkGroupList == ''" class="form-control">{{ $ml.get('general.notSelected')
                        }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-workplan">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedWorkGroupList != ''" class="btn btn-danger"
                          @click="clearFilterWorkPlans()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group" v-show="modules.diningHall">
                    <label>{{ $ml.get('filters.filterFoodGroup') }}</label>
                    <div class="input-group">
                      <label v-show="checkedFoodGroupList != ''" class="form-control tdb-box">{{ checkedFoodGroupList
                        }}</label>
                      <label v-show="checkedFoodGroupList == ''" class="form-control">{{ $ml.get('general.notSelected')
                        }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-diningHall">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedFoodGroupList != ''" class="btn btn-danger"
                          @click="clearFilterFoodGroups()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>{{ $ml.get('filters.filterState') }}</label>
                    <div class="input-group">
                      <label v-show="checkedStateList != ''" class="form-control tdb-box">{{ checkedStateList }}</label>
                      <label v-show="checkedStateList == ''" class="form-control">{{ $ml.get('general.notSelected')
                        }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-state">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedStateList != ''" class="btn btn-danger" @click="clearFilterStates()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-sm-6">
                      <span>{{ $ml.get('filters.filterDeleted') }}</span>
                      <span class="form-control checkbox">
                        <label style="margin-left:20px;">
                          <input :checked="filters.isActive"
                            @change="filters.isActive == true ? filters.isActive = false : filters.isActive = true"
                            type="checkbox" />
                          {{ $ml.get('filters.filterNotShow') }}
                        </label>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="callout callout-info" style="margin-top:10px;">
                <div class="row">
                  <div class="col-md-3 col-xs-6">
                    <select @change="changeFilterExtraField1($event)" class="form-control input-sm"
                      style="margin-bottom:5px;">
                      <option :selected="filters.extraField1key == 0" value>
                        {{ $ml.get('filters.filterSelectExtraFields') }}</option>
                      <option v-for="extraField in extraFieldList" :key="extraField.id" :value="extraField.id"
                        :selected="extraField.id == filters.extraField1key">{{ extraField.name }}</option>
                    </select>
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <input v-model="filters.extraField1value" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <select @change="changeFilterExtraField2($event)" class="form-control input-sm"
                      style="margin-bottom:5px;">
                      <option :selected="filters.extraField2key == 0" value>
                        {{ $ml.get('filters.filterSelectExtraFields') }}</option>
                      <option v-for="extraField in extraFieldList" :key="extraField.id" :value="extraField.id"
                        :selected="extraField.id == filters.extraField2key">{{ extraField.name }}</option>
                    </select>
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <input v-model="filters.extraField2value" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <select @change="changeFilterExtraField3($event)" class="form-control input-sm"
                      style="margin-bottom:5px;">
                      <option :selected="filters.extraField3key == 0" value>
                        {{ $ml.get('filters.filterSelectExtraFields') }}</option>
                      <option v-for="extraField in extraFieldList" :key="extraField.id" :value="extraField.id"
                        :selected="extraField.id == filters.extraField3key">{{ extraField.name }}</option>
                    </select>
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <input v-model="filters.extraField3value" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <select @change="changeFilterExtraField4($event)" class="form-control input-sm"
                      style="margin-bottom:5px;">
                      <option :selected="filters.extraField4key == 0" value>
                        {{ $ml.get('filters.filterSelectExtraFields') }}</option>
                      <option v-for="extraField in extraFieldList" :key="extraField.id" :value="extraField.id"
                        :selected="extraField.id == filters.extraField4key">{{ extraField.name }}</option>
                    </select>
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <input v-model="filters.extraField4value" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              <i class="fa fa-remove"></i>
              <span>{{ $ml.get('filters.filterCancel') }}</span>
            </button>
            <button @click="filtersClear()" class="btn btn-warning ">
              <i class="fa fa-trash-o"></i>
              <span>{{ $ml.get('filters.filterClear') }}</span>
            </button>
            <button @click="getEmployees()" class="btn btn-success " data-dismiss="modal">
              <i class="fa fa-search"></i>
              <span>{{ $ml.get('filters.filterApply') }}</span>
            </button>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!--DEPARTMAN SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-department" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterDepartments') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <a @click="isCheckDeps == true ? getCheckDepartmentAll(false) : getCheckDepartmentAll(true)">
                <span v-text="isCheckDeps == true ? $ml.get('general.removeAll') : $ml.get('general.selectAll')"></span>
              </a>
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="dep in sortableDepartmentList" :key="dep.id">
                  <label style="margin-left:20px;">
                    <input :checked="dep.check"
                      @change="dep.check == true ? changeFilterDep(dep, false) : changeFilterDep(dep, true)"
                      type="checkbox" />
                    {{ dep.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="sortableDepartmentList.length == 0">
                  {{ $ml.get('employees.departmentNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" M data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--DEPARTMAN SEÇ MODAL END -->
      <!--DURUM SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-state" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterState') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="state in stateList" :key="state.id">
                  <label style="margin-left:20px;">
                    <input :checked="state.isCheck"
                      @change="state.isCheck == true ? state.isCheck = false : state.isCheck = true" type="checkbox" />
                    {{ state.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="stateList.length == 0">
                  {{ $ml.get('employees.stateNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--DURUM SEÇ MODAL END -->
      <!--STATU SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-status" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterStatus') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="status in statuList" :key="status.id">
                  <label style="margin-left:20px;">
                    <input :checked="status.isCheck"
                      @change="status.isCheck == true ? status.isCheck = false : status.isCheck = true"
                      type="checkbox" />
                    {{ status.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="statuList.length == 0">
                  {{ $ml.get('employees.statusNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--STATU SEÇ MODAL END -->
      <!--GEÇİŞ GRUBU SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-access" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterAccessGroup') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="acc in accessGroupList" :key="acc.id">
                  <label style="margin-left:20px;">
                    <input :checked="acc.isCheck"
                      @change="acc.isCheck == true ? acc.isCheck = false : acc.isCheck = true" type="checkbox" />
                    {{ acc.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="accessGroupList.length == 0">
                  {{ $ml.get('accessGroups.accessGroupNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--GEÇİŞ GRUBU SEÇ MODAL END -->
      <!--ÇALIŞMA PLANI SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-workplan" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterWorkPlan') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="work in workGroupList" :key="work.id">
                  <label style="margin-left:20px;">
                    <input :checked="work.isCheck"
                      @change="work.isCheck == true ? work.isCheck = false : work.isCheck = true" type="checkbox" />
                    {{ work.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="workGroupList.length == 0">
                  {{ $ml.get('workPlans.workPlanNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--ÇALIŞMA PLANI SEÇ MODAL END -->
      <!--YEMEK PLANI SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-diningHall" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterWorkPlan') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="foodGroup in foodGroupList" :key="foodGroup.id">
                  <label style="margin-left:20px;">
                    <input :checked="foodGroup.isCheck"
                      @change="foodGroup.isCheck == true ? foodGroup.isCheck = false : foodGroup.isCheck = true"
                      type="checkbox" />
                    {{ foodGroup.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="foodGroupList.length == 0">
                  {{ $ml.get('foodGroups.foodGroupNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--YEMEK PLANI SEÇ MODAL END -->
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      orderEmpList: 1,
      filters: {
        nameOrCardNumber: "",
        sicilOrTerminalNo: null,
        departments: [],
        accessGroup: [],
        identityNo: "",
        documentNoOrMail: "",
        foodGroup: [],
        workGroupId: [],
        title: "",
        stateId: [],
        statuId: [],
        plateNo: "",
        extraField1key: 0,
        extraField1value: "",
        extraField2key: 0,
        extraField2value: "",
        extraField3key: 0,
        extraField3value: "",
        extraField4key: 0,
        extraField4value: "",
        isVisitor: false,
        isActive: true
      },
      isCheckDeps: false,
      sortableDepTrees: [],
      batchAllowence: {
        allowenceId: null,
        description: "",
        holidayPass: false,
        startDate: null,
        endDate: null,
        allowenceType: 0,
        allowenceTime: "00:00",
        missingTime: "00:00",
        equalTheMissingTime: false
      },
      batchWorkGroup: {
        startDate: null,
        endDate: null,
        workGroupId: 0,
        holidayPass: true,
        description: ""
      },
      batchMovement: {
        startDate: null,
        endDate: null,
        entryTime: "00:00",
        entryPointId: 0,
        entryPointStatus: 1,
        isTwoMovement: false,
        exitTime: "00:00",
        exitPointId: 0,
        exitPointStatus: 2
      },
      isCheckOvertime: false,
      batchOvertime: {
        startDate: null,
        endDate: null
      },
      batchOvertimes: [],
      days: [
        { value: 1, name: this.$ml.get("general.monday"), check: true },
        { value: 2, name: this.$ml.get("general.tuesday"), check: true },
        { value: 3, name: this.$ml.get("general.wednesday"), check: true },
        { value: 4, name: this.$ml.get("general.thursday"), check: true },
        { value: 5, name: this.$ml.get("general.friday"), check: true },
        { value: 6, name: this.$ml.get("general.saturday"), check: true },
        { value: 7, name: this.$ml.get("general.sunday"), check: true }
      ],
      batchPayrollStartDate: null,
      includePassiveMovements: false,
      doNotDeleteOvertimes: true,
      batchInfo: {
        newDepartmentId: 0,
        newStatusId: 0,
        newStateId: 0,
        newFoodGroupId: 0,
        newValidityStartDate: null,
        newValidityEndDate: null,
      },
      workPlaces: {
        workPlaceId: 0,
        description: "",
        startDate: null,
        endDate: null
      },
      isCheck: true,
      employees: [],
      departments: [],
      foodGroups: [],
      titles: [],
      states: [],
      status: [],
      extrafields: [],
      workGroups: [],
      accessGroups: [],
      workPlaceDefinitions: [],
      allowences: [],
      readers: [],
      searchText: "",
      isLoading: false,
      isLoadingEmployee: false
    };
  },
  computed: {
    defaultFilters() {
      return this.$store.getters.getDefaultFilters;
    },
    modules() {
      return this.$store.getters.getModules;
    },
    authControl() {
      return this.$store.getters.getAuthTanimlamalar;
    },
    employeeFilteredList() {
      if (this.orderEmpList == 1) {
        return this.employees.sort((a, b) => {
          return this.turkishToUpper(a.sicilNo).localeCompare(this.turkishToUpper(b.sicilNo));
        });
      } else if (this.orderEmpList == 2) {
        return this.employees.sort((a, b) => {
          return this.turkishToUpper(b.sicilNo).localeCompare(this.turkishToUpper(a.sicilNo));
        });
      } else if (this.orderEmpList == 3) {
        return this.employees.sort((a, b) => {
          return this.turkishToUpper(a.name).localeCompare(this.turkishToUpper(b.name));
        });
      } else {
        return this.employees.sort((a, b) => {
          return this.turkishToUpper(b.name).localeCompare(this.turkishToUpper(a.name));
        });
      }
    },
    departmentList() {
      return this.departments;
    },
    sortableDepartmentList() {
      return this.sortableDepTrees;
    },
    checkedDepartmentList() {
      var checkedList = "";
      var list = this.sortableDepartmentList.forEach(a => {
        if (a.check == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    foodGroupList() {
      return this.foodGroups;
    },
    checkedFoodGroupList() {
      var checkedList = "";
      var list = this.foodGroupList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    batchOvertimeList() {
      return this.batchOvertimes;
    },
    titleList() {
      return this.titles;
    },
    stateList() {
      return this.states;
    },
    workPlaceDefinitionList() {
      return this.workPlaceDefinitions;
    },
    checkedStateList() {
      var checkedList = "";
      var list = this.stateList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    statuList() {
      return this.status;
    },
    checkedStatusList() {
      var checkedList = "";
      var list = this.statuList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    extraFieldList() {
      return this.extrafields;
    },
    workGroupList() {
      return this.workGroups;
    },
    checkedWorkGroupList() {
      var checkedList = "";
      var list = this.workGroupList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    accessGroupList() {
      return this.accessGroups;
    },
    checkedAccessGroupList() {
      var checkedList = "";
      var list = this.accessGroupList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    allowenceList() {
      return this.allowences;
    },
    readerList() {
      return this.readers;
    },
    dayList() {
      return this.days;
    },
    filtered() {
      var search = this.turkishToUpper(this.searchText)
      if (search) {
        return this.employeeFilteredList.filter(item => {
          return search
            .split(" ")
            .every(v => this.turkishToUpper(item.name).includes(v));
        });
      } else {
        return this.employeeFilteredList;
      }
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 340;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowHeightConfirmOvertimeSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 340;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  filters: {
    toDateFormatGet(str, format) {
      if (!str) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye =
          str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        str = new Date(str);
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    turkishToUpper(text) {
      var letters = { "i": "İ", "ş": "Ş", "ğ": "Ğ", "ü": "Ü", "ö": "Ö", "ç": "Ç", "ı": "I" };
      text = text.replace(/(([iışğüçö]))/g, function (letter) { return letters[letter]; })
      return text.toUpperCase();
    },
    setOrderEmp(number) {
      if (number == 1) {
        if (this.orderEmpList == 1) {
          this.orderEmpList = 2;
        } else {
          this.orderEmpList = 1;
        }
      } else {
        if (this.orderEmpList == 3) {
          this.orderEmpList = 4;
        } else {
          this.orderEmpList = 3;
        }
      }
    },
    toDateFormat(str, format) {
      if (!str) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye =
          str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        str = new Date(str);
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika =
          str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    changeEntryDevice(event) {
      this.batchMovement.entryPointId = event.target.value;
    },
    changeEntryStatus(event) {
      this.batchMovement.entryPointStatus = event.target.value;
    },
    changeExitDevice(event) {
      this.batchMovement.exitPointId = event.target.value;
    },
    changeExitStatus(event) {
      this.batchMovement.exitPointStatus = event.target.value;
    },
    changeAllowence(event) {
      this.batchAllowence.allowenceId = event.target.value;
    },
    changeAllowenceType(event) {
      this.batchAllowence.allowenceType = event.target.value;
    },
    changeWorkGroup(event) {
      this.batchWorkGroup.workGroupId = event.target.value;
    },
    changeDepartment(event) {
      this.batchInfo.newDepartmentId = event.target.value;
    },
    changeStatu(event) {
      this.batchInfo.newStatusId = event.target.value;
    },
    changeWorkPlace(event) {
      this.workPlaces.workPlaceId = event.target.value;
    },
    changeState(event) {
      this.batchInfo.newStateId = event.target.value;
    },
    changeFoodGroup(event) {
      this.batchInfo.newFoodGroupId = event.target.value;
    },
    changeAccessGroup(event) {
      this.batchInfo.newAccessGroupId = event.target.value;
    },
    checkEmployees() {
      this.isCheck = !this.isCheck;
      let aList = this.employees;
      aList.forEach(doc => {
        if (doc.check == !this.isCheck) {
          doc.check = this.isCheck;
        }
      });
    },
    async getSelectedEmployeeList() {
      let aList = this.employees;
      let selectedEmployees = aList.filter(function (employee) {
        return employee.check == true;
      });
      let selectedEmployeeList = [];
      await selectedEmployees.forEach(emp => {
        selectedEmployeeList.push(emp.id);
      });
      return selectedEmployeeList;
    },
    filtersClear() {
      this.filters.nameOrCardNumber = "";
      this.filters.sicilOrTerminalNo = null;
      this.filters.departments = [];
      this.filters.accessGroup = [];
      this.filters.identityNo = "";
      this.filters.documentNoOrMail = "";
      this.filters.foodGroup = [];
      this.filters.workGroupId = [];
      this.filters.title = "";
      this.filters.stateId = [];
      this.filters.statuId = [];
      this.filters.plateNo = "";
      this.filters.extraField1key = 0;
      this.filters.extraField1value = "";
      this.filters.extraField2key = 0;
      this.filters.extraField2value = "";
      this.filters.extraField3key = 0;
      this.filters.extraField3value = "";
      this.filters.extraField4key = 0;
      this.filters.extraField4value = "";
      this.filters.isVisitor = false;
      this.filters.isActive = true;
      this.accessGroupList.forEach(a => {
        a.isCheck = false;
      });
      this.sortableDepartmentList.forEach(a => {
        a.check = false;
      });
      this.foodGroupList.forEach(a => {
        a.isCheck = false;
      });
      this.workGroupList.forEach(a => {
        a.isCheck = false;
      });
      this.stateList.forEach(a => {
        a.isCheck = false;
      });
      this.statuList.forEach(a => {
        a.isCheck = false;
      });
    },
    changeFilterDepartments(event) {
      this.filters.departmentId = event.target.value;
    },
    changeFilterTitles(event) {
      this.filters.title = event.target.value;
    },
    changeFilterAccessGroups(event) {
      this.filters.accessGroup = event.target.value;
    },
    changeFilterFoodGroups(event) {
      this.filters.foodGroup = event.target.value;
    },
    changeFilterStatus(event) {
      this.filters.statuId = event.target.value;
    },
    changeFilterStates(event) {
      this.filters.stateId = event.target.value;
    },
    changeFilterWorkGroups(event) {
      this.filters.workGroupId = event.target.value;
    },
    changeFilterExtraField1(event) {
      this.filters.extraField1key = event.target.value;
      if (!this.filters.extraField1key) {
        this.filters.extraField1key = 0;
      }
    },
    changeFilterExtraField2(event) {
      this.filters.extraField2key = event.target.value;
      if (!this.filters.extraField2key) {
        this.filters.extraField2key = 0;
      }
    },
    changeFilterExtraField3(event) {
      this.filters.extraField3key = event.target.value;
      if (!this.filters.extraField3key) {
        this.filters.extraField3key = 0;
      }
    },
    changeFilterExtraField4(event) {
      this.filters.extraField4key = event.target.value;
      if (!this.filters.extraField4key) {
        this.filters.extraField4key = 0;
      }
    },
    async changeFilterDep(dep, checkValue) {
      dep.check = checkValue;
      this.sortableDepartmentList.forEach(doc => {
        if (doc.mainDepartmentId == dep.id) {
          doc.check = checkValue;
          this.changeFilterDep(doc, checkValue);
        }
      });
    },
    async clearFilterDepartments() {
      this.filters.departments = [];
      await this.sortableDepartmentList.forEach(doc => {
        if (doc.check == true) {
          doc.check = false;
        }
      });
    },
    async clearFilterAccessGroup() {
      this.filters.accessGroup = [];
      await this.accessGroupList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterStates() {
      this.filters.stateId = [];
      await this.stateList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterStatus() {
      this.filters.statuId = [];
      await this.statuList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterWorkPlans() {
      this.filters.workGroupId = [];
      await this.workGroupList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterFoodGroups() {
      this.filters.foodGroup = [];
      await this.foodGroupList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async getCheckDepartmentAll(value) {
      this.sortableDepartmentList.forEach(dep => {
        dep.check = value;
      });
      this.isCheckDeps = !this.isCheckDeps;
    },
    async getCheckDepartmentList() {
      let aList = this.sortableDepartmentList;
      this.filters.departments = [];
      await aList.forEach(doc => {
        if (doc.check == true) {
          this.filters.departments.push(doc.id);
        }
      });
      let aList2 = this.accessGroupList;
      this.filters.accessGroup = [];
      await aList2.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.accessGroup.push(doc.id);
        }
      });
      let aList3 = this.workGroupList;
      this.filters.workGroupId = [];
      await aList3.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.workGroupId.push(doc.id);
        }
      });
      let aList4 = this.foodGroupList;
      this.filters.foodGroup = [];
      await aList4.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.foodGroup.push(doc.id);
        }
      });
      let aList5 = this.statuList;
      this.filters.statuId = [];
      await aList5.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.statuId.push(doc.id);
        }
      });
      let aList6 = this.stateList;
      this.filters.stateId = [];
      await aList6.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.stateId.push(doc.id);
        }
      });
    },
    async downloadExcelTemplate() {
      try {
        this.isLoading = true;
        const response = await this.$axios
          .get(
            "/Meal/Template",
            {
              responseType: "blob",
            }
          )
          .then((response) => {
            if (response.status == 200) {
              var data = new Blob([response.data]);
              var csvUrl = window.URL.createObjectURL(data);
              var tempLink = document.createElement("a");
              tempLink.href = csvUrl;
              var today = new Date().toLocaleString("tr-TR");
              tempLink.setAttribute(
                "download",
                "yemekhane_bakiye_sablonu_" +
                today
                  .replaceAll(".", "_")
                  .replaceAll(" ", "_")
                  .replaceAll(":", "_") +
                ".xlsx"
              );
              tempLink.click();
            } else {
              alertify.warning(
                this.$ml.get("alerts.youAreNotAuthorizedForThisAction")
              );
            }
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status == 401) {
                this.refreshToken();
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    async uploadExcelTemplate() {
      if (!this.$refs.file.files[0]) {
        alertify.warning(this.$ml.get("alerts.pleaseSelectFile"));
        return;
      }
      try {
        this.isLoading = true;
        const formData = new FormData();
        formData.append("file", this.$refs.file.files[0]);
        const response = await this.$axios
          .post(
            "/Meal/Import",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((response) => {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.transactionSuccessfull"));
            } else {
              alertify.warning(
                this.$ml.get("alerts.youAreNotAuthorizedForThisAction")
              );
            }
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status == 401) {
                this.refreshToken();
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    async getAccessGroups() {
      try {
        const accessGroups = [];
        const response = await this.$axios
          .get("/AccessGroups")
          .then(response => {
            response.data.forEach(doc => {
              accessGroups.push({
                id: doc.id,
                name: doc.name,
                isNewReaderAdd: doc.isNewReaderAdd,
                selectedReaders: doc.postReaders,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.accessGroups = accessGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getDepartments() {
      const departments = [];
      try {
        const response = await this.$axios
          .get("/Department")
          .then(response => {
            response.data.forEach(doc => {
              departments.push({
                id: doc.id,
                name: doc.name,
                mainDepartmentId: doc.mainDepartmentId,
                isActive: doc.isActive,
                locationTree: doc.locationTree,
                userId: doc.userId,
                check: false
              });
            });
            departments.sort((a, b) => {
              if (a.locationTree < b.locationTree) return -1;
              if (a.locationTree > b.locationTree) return 0;
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.departments = departments;
        this.sortableTrees();
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error);
      }
    },
    sortableTrees() {
      this.sortableDepTrees = [];
      this.departments.forEach(dep => {
        if (dep.mainDepartmentId == null) {
          this.sortableDepTrees.push(dep);
          this.subDepImport(dep);
        }
      });
    },
    subDepImport(dep) {
      let departments2 = this.departments;
      let subDep = departments2.filter(function (doc) {
        return doc.mainDepartmentId == dep.id;
      });
      if (subDep.length > 0) {
        var ekle = "";
        let ek = subDep[0].locationTree.split("/");
        for (let index = 0; index < ek.length - 3; index++) {
          ekle = "--/" + ekle;
        }
        subDep.forEach(doc2 => {
          doc2.name = ekle + " " + doc2.name;
          this.sortableDepTrees.push(doc2);
          this.subDepImport(doc2);
        });
      }
    },
    async getFoodGroups() {
      try {
        const foodGroups = [];
        const response = await this.$axios
          .get("/FoodGroups")
          .then(response => {
            response.data.forEach(doc => {
              foodGroups.push({
                id: doc.id,
                name: doc.name,
                type: doc.type,
                singleFoodEachMeal: doc.singleFoodEachMeal,
                meals: doc.meals,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.foodGroups = foodGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getStatus() {
      try {
        const status = [];
        const response = await this.$axios
          .get("/Employees/getStatus")
          .then(response => {
            response.data.forEach(doc => {
              status.push({
                id: doc.id,
                name: doc.name,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.status = status;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getTitles() {
      try {
        const titles = [];
        const response = await this.$axios
          .get("/Employees/getTitles")
          .then(response => {
            response.data.forEach(doc => {
              titles.push({
                name: doc
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.titles = titles;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getStates() {
      try {
        const states = [];
        const response = await this.$axios
          .get("/Employees/getStates")
          .then(response => {
            response.data.forEach(doc => {
              states.push({
                id: doc.id,
                name: doc.name,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.states = states;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getWorkGroups() {
      try {
        const workGroups = [];
        const response = await this.$axios
          .get("/WorkGroups")
          .then(response => {
            response.data.forEach(doc => {
              workGroups.push({
                id: doc.id,
                shortCode: doc.shortCode,
                name: doc.name,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.workGroups = workGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getExtraFields() {
      try {
        const extrafields = [];
        const response = await this.$axios
          .get("/ExtraField")
          .then(response => {
            response.data.forEach(doc => {
              extrafields.push({
                id: doc.id,
                name: doc.definition
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.extrafields = extrafields;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getAllowences() {
      try {
        this.isLoading = true;
        const allowences = [];
        const response = await this.$axios
          .get("/Allowences")
          .then(response => {
            response.data.forEach(doc => {
              allowences.push({
                id: doc.id,
                shortCode: doc.shortCode,
                name: doc.name,
                monthlyPayrollId: doc.monthlyPayrollId,
                dailyPayrollId: doc.dailyPayrollId,
                dayTime: doc.dayTime,
                colorCode: doc.colorCode
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.allowences = allowences;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    async getEmployees() {
      try {
        this.isLoadingEmployee = true;
        await this.getCheckDepartmentList();
        const employees = [];
        let filters2 = this.filters;
        const response = await this.$axios
          .post("/Employees/getByFilter", {
            nameOrCardNumber: filters2.nameOrCardNumber,
            sicilOrTerminalNo: filters2.sicilOrTerminalNo,
            departments: filters2.departments,
            accessGroup: filters2.accessGroup,
            identityNo: filters2.identityNo,
            documentNoOrMail: filters2.documentNoOrMail,
            foodGroup: filters2.foodGroup,
            workGroupId: filters2.workGroupId,
            title: filters2.title,
            stateId: filters2.stateId,
            statuId: filters2.statuId,
            plateNo: filters2.plateNo,
            extraField1key: filters2.extraField1key,
            extraField1value: filters2.extraField1value,
            extraField2key: filters2.extraField2key,
            extraField2value: filters2.extraField2value,
            extraField3key: filters2.extraField3key,
            extraField3value: filters2.extraField3value,
            extraField4key: filters2.extraField4key,
            extraField4value: filters2.extraField4value,
            isVisitor: filters2.isVisitor,
            isActive: filters2.isActive
          })
          .then(response => {
            response.data.forEach(doc => {
              employees.push({
                id: doc.id,
                name: doc.name,
                sicilNo: doc.sicilNo,
                title: doc.title,
                check: true
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingEmployee = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingEmployee = false;
                return;
              }
            }
          });
        this.employees = employees;
        this.isLoadingEmployee = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingEmployee = false;
      }
    },
    async getReaders() {
      try {
        const readers = [];
        const response = await this.$axios
          .get("/Terminal/GetReaders")
          .then(response => {
            if (response.status == 200) {
              response.data.forEach(doc => {
                if (
                  doc.doorType == 0 ||
                  doc.doorType == 1 ||
                  doc.doorType == 2 ||
                  doc.doorType == 3 ||
                  doc.doorType == 5
                ) {
                  readers.push({
                    readerNo: doc.readerNo,
                    readerId: doc.readerId,
                    terminalId: doc.terminalId,
                    terminalNo: doc.terminalNo,
                    ipAddress: doc.ipAddress,
                    name: doc.name,
                    check: false
                  });
                }
              });
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
              if (error.response.status == 500) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.readers = readers;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası : " + error.message);
      }
    },
    async setBatchAllowence() {
      if (this.batchAllowence.allowenceId == null) {
        alertify.warning(this.$ml.get("alerts.allowenceNotSelected"));
        return;
      }
      try {
        this.isLoading = true;
        let days = await this.selectedDays();
        let empIds = await this.getSelectedEmployeeList();
        let batchAllowence1 = this.batchAllowence;
        const response = await this.$axios
          .post("/BatchOperations/BatchAllowence", {
            empIds: empIds,
            days: days,
            allowenceId: batchAllowence1.allowenceId,
            description: batchAllowence1.description,
            holidayPass: batchAllowence1.holidayPass,
            startDate: batchAllowence1.startDate,
            endDate: batchAllowence1.endDate,
            allowenceType: batchAllowence1.allowenceType,
            allowenceTime: batchAllowence1.allowenceTime,
            equalTheMissingTime: batchAllowence1.equalTheMissingTime,
            missingTime: batchAllowence1.missingTime
          })
          .then(response => {
            if (response.status == 200) {
              alertify.success(
                this.$ml.get("batchOperations.batchAllowencesSuccessfully")
              );
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Hata :" + error.message);
        this.isLoading = false;
      }
    },
    selectedDays() {
      let selectedDays = [];
      let aList = this.days;
      aList.forEach(doc => {
        if (doc.check == true) {
          selectedDays.push(doc.value);
        }
      });
      return selectedDays;
    },
    async setBatchMovement() {
      if (
        this.batchMovement.startDate == null ||
        this.batchMovement.endDate == null ||
        this.batchMovement.startDate > this.batchMovement.endDate
      ) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      try {
        this.isLoading = true;
        let days = await this.selectedDays();
        let empIds = await this.getSelectedEmployeeList();
        var exit =
          this.batchMovement.isTwoMovement == false
            ? null
            : this.batchMovement.exitTime;
        let batchMovement = this.batchMovement;
        const response = await this.$axios
          .post("/BatchOperations/BatchMovement", {
            empIds: empIds,
            days: days,
            entryTime: batchMovement.entryTime,
            exitTime: exit,
            startDate: batchMovement.startDate,
            endDate: batchMovement.endDate,
            entryPointId: batchMovement.entryPointId,
            entryPointStatus: batchMovement.entryPointStatus,
            exitPointId: batchMovement.exitPointId,
            exitPointStatus: batchMovement.exitPointStatus
          })
          .then(response => {
            if (response.status == 200) {
              alertify.success(
                this.$ml.get("batchOperations.batchMovementSuccessfully")
              );
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Hata :" + error.message);
        this.isLoading = false;
      }
    },
    async setBatchWorkGroup() {
      if (
        this.batchWorkGroup.startDate == null ||
        this.batchWorkGroup.endDate == null ||
        this.batchWorkGroup.startDate > this.batchWorkGroup.endDate
      ) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      try {
        this.isLoading = true;
        let empIds = await this.getSelectedEmployeeList();
        let batchWorkGroup = this.batchWorkGroup;
        const response = await this.$axios
          .post("/BatchOperations/BatchWorkGroupChange", {
            empIds: empIds,
            startDate: batchWorkGroup.startDate,
            endDate: batchWorkGroup.endDate,
            workGroupId: batchWorkGroup.workGroupId,
            holidayPass: batchWorkGroup.holidayPass,
            description: batchWorkGroup.description
          })
          .then(response => {
            if (response.status == 200) {
              alertify.success(
                this.$ml.get("batchOperations.batchWorkPlanUpdateSuccessfully")
              );
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Hata :" + error.message);
        this.isLoading = false;
      }
    },
    async setBatchWorkPlace() {
      if(this.workPlaces.workPlaceId == null) {
        alertify.warning(this.$ml.get("alerts.pleaseSelect"));
        return;
      }
      if (
        this.workPlaces.startDate == null ||
        this.workPlaces.endDate == null ||
        this.workPlaces.startDate > this.workPlaces.endDate
      ) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      try {
        this.isLoading = true;
        let empIds = await this.getSelectedEmployeeList();
        var data = [];
        empIds.forEach(emp => {
          data.push({
            employeeId: emp,
            workPlaceId: this.workPlaces.workPlaceId,
            startDate: this.workPlaces.startDate,
            endDate: this.workPlaces.endDate,
            description: this.workPlaces.description
          });
        });
        const response = await this.$axios
          .post("/EmployeeWorkPlace/BulkAdd", data)
          .then(response => {
            if (response.status == 200) {
              alertify.success(
                this.$ml.get("batchOperations.batchInformationUpdateSuccessfully")
              );
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Hata :" + error.message);
        this.isLoading = false;
      }
    },
    async setBatchPayroll() {
      if (this.batchPayrollStartDate == null) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      try {
        this.isLoading = true;
        let empIds = await this.getSelectedEmployeeList();
        let batchPayrollStartDate = this.batchPayrollStartDate;
        const response = await this.$axios
          .post("/BatchOperations/BatchPayroll", {
            empIds: empIds,
            date: batchPayrollStartDate,
            includePassiveMovements: this.includePassiveMovements,
            doNotDeleteOvertimes: this.doNotDeleteOvertimes
          })
          .then(response => {
            if (response.status == 200) {
              alertify.success(
                this.$ml.get("alerts.payrollOfTheEmployeesWasRecalculated")
              );
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Hata :" + error.message);
        this.isLoading = false;
      }
    },
    async setBatchInformation() {
      try {
        this.isLoading = true;
        let empIds = await this.getSelectedEmployeeList();
        let batchInfo = this.batchInfo;
        const response = await this.$axios
          .post("/BatchOperations/BatchInformationChange", {
            empIds: empIds,
            newDepartmentId: batchInfo.newDepartmentId,
            newStateId: batchInfo.newStateId,
            newStatusId: batchInfo.newStatusId,
            newFoodGroupId: batchInfo.newFoodGroupId,
            newAccessGroupId: batchInfo.newAccessGroupId,
            newValidityStartDate: batchInfo.newValidityStartDate,
            newValidityEndDate: batchInfo.newValidityEndDate
          })
          .then(response => {
            if (response.status == 200) {
              alertify.success(
                this.$ml.get("batchOperations.batchInformationUpdateSuccessfully")
              );
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Hata :" + error.message);
        this.isLoading = false;
      }
    },
    checkAllOvertime() {
      if (this.isCheckOvertime == true) {
        this.batchOvertimes.forEach(over => {
          over.check = false;
        });
      } else {
        this.batchOvertimes.forEach(over => {
          over.check = true;
        });
      }
      this.isCheckOvertime = !this.isCheckOvertime;
    },
    overtimeStyleControl(calculated, confirmed) {
      if (calculated && confirmed) {
        var hesaplanan = new Date("1900-01-01T" + calculated);
        var onaylanan = new Date("1900-01-01T" + confirmed);
        if (onaylanan > hesaplanan) {
          return "border-color:#dd4b39;";
        } else {
          return "";
        }
      }
    },
    overtimeControl(calculated, confirmed, name, date) {
      if (calculated && confirmed) {
        var hesaplanan = new Date("1900-01-01T" + calculated);
        var onaylanan = new Date("1900-01-01T" + confirmed);
        if (onaylanan > hesaplanan) {
          var tarih = this.toDateFormat(date, "gg.aa.yyyy");
          alertify.error(
            this.$ml.get(
              "alerts.confirmedOvertimeCannotBeGreaterThanCalculated"
            ) +
            " : " +
            name +
            " - " +
            tarih
          );
        } else {
        }
      }
    },
    async prepareBatchOverTime() {
      var list = [];
      var key = true;
      await this.batchOvertimeList.forEach(overtime => {
        if (overtime.check == true) {
          var onaylanan = new Date("1900-01-01T" + overtime.confirmed);
          var hesaplanan = new Date("1900-01-01T" + overtime.confirmed);
          if (onaylanan > hesaplanan) {
            alertify.error(this.$ml.get("alerts.checkConfirmedTimes"));
            key = false;
          } else {
            list.push({
              overTimeId: overtime.overTimeId,
              confirmedTime: overtime.confirmed
            });
          }
        }
      });
      return { list: list, key: key };
    },
    async setBatchOvertime() {
      try {
        this.isLoading = true;
        var veri = await this.prepareBatchOverTime();
        if (veri.list.length > 0 && veri.key == true) {
          console.log(veri.list);
          const response = await this.$axios
            .post("/BatchOperations/BatchConfirmOvertimes", veri.list)
            .then(response => {
              if (response.status == 200) {
                alertify.success(
                  this.$ml.get("alerts.confirmationOvertimeSuccessfully")
                );
              }
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoading = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoading = false;
                  return;
                }
              }
            });
        } else {
          alertify.warning(this.$ml.get("alerts.selectedRecordNotFound"));
        }
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    async getBatchOvertimes() {
      if (
        this.batchOvertime.startDate == null ||
        this.batchOvertime.endDate == null ||
        this.batchOvertime.startDate > this.batchOvertime.endDate
      ) {
        alertify.warning(this.$ml.get("alerts.invalidDate"));
        return;
      }
      try {
        this.isLoading = true;
        let empIds = await this.getSelectedEmployeeList();
        const batchOvertimes = [];
        const response = await this.$axios
          .post("/BatchOperations/GetBatchOvertimes", {
            empIds: empIds,
            startDate: this.batchOvertime.startDate,
            endDate: this.batchOvertime.endDate
          })
          .then(response => {
            response.data.forEach(doc => {
              var confirmed = this.toDateFormat(doc.confirmed, "ss:dd");
              var calculated = this.toDateFormat(doc.calculated, "ss:dd");
              batchOvertimes.push({
                sicilNo: doc.sicilNo,
                name: doc.name,
                date: doc.date,
                workGroupName: doc.workGroupName,
                entry: doc.entry,
                exit: doc.exit,
                calculated: calculated,
                confirmed: confirmed,
                empId: doc.empId,
                overTimeId: doc.overTimeId,
                check: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.batchOvertimes = batchOvertimes;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    async getWorkPlaceDefinitions() {
      try {
        const response = await this.$axios
          .get("/WorkPlaceDefinition/GetAll")
          .then(response => {
            this.workPlaceDefinitions = response.data;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    getDefaultDate() {
      let toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      this.batchAllowence.startDate = yil + "-" + ay + "-" + gun + "T00:00";
      this.batchWorkGroup.startDate = yil + "-" + ay + "-" + gun + "T00:00";
      this.batchAllowence.entryTime = yil + "-" + ay + "-" + gun + "T00:00";
      this.batchPayrollStartDate = yil + "-" + ay + "-" + gun + "T00:00";
      this.batchMovement.startDate = yil + "-" + ay + "-" + gun;
      this.batchOvertime.startDate = yil + "-" + ay + "-" + gun;
      this.batchAllowence.endDate = yil + "-" + ay + "-" + gun + "T23:59";
      this.batchWorkGroup.endDate = yil + "-" + ay + "-" + gun + "T23:59";
      this.batchMovement.endDate = yil + "-" + ay + "-" + gun;
      this.batchOvertime.endDate = yil + "-" + ay + "-" + gun;
    },
    setUserAuthorityFilter(filter) {
      this.filters = filter;
      this.sortableDepartmentList.forEach(doc => {
        filter.departments.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.check = true;
          }
        });
      });
      this.workGroupList.forEach(doc => {
        filter.workGroupId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.accessGroupList.forEach(doc => {
        filter.accessGroup.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.foodGroupList.forEach(doc => {
        filter.foodGroup.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.stateList.forEach(doc => {
        filter.stateId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.statuList.forEach(doc => {
        filter.statuId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
    },
    async getAuthControl() {
      if (this.authControl == 1) {
        alertify.warning(
          this.$ml.get("alerts.youAreOnlyAuthorizedToViewThisPage")
        );
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getAuthControl();
    await this.getDefaultDate();
    await this.getDepartments();
    await this.getAccessGroups();
    await this.getFoodGroups();
    await this.getStatus();
    await this.getStates();
    await this.getTitles();
    await this.getWorkGroups();
    await this.getExtraFields();
    await this.getAllowences();
    await this.getReaders();
    await this.getWorkPlaceDefinitions();
    if (this.defaultFilters) {
      var filter = this.defaultFilters;
      this.setUserAuthorityFilter(filter);
      await this.getEmployees();
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/operations/Operations.vue